module.exports = __webpack_public_path__ + "static/competition_illustration-59e3fba58c4d37ba12d94119a32eec98.png";